import Grid, { IGridProps } from '../../../Grid';

interface IPopperContentProps extends IGridProps {
}

const PopperContent = (props: IPopperContentProps) => (
  <Grid p={2} {...props} />
);

export default PopperContent;
